//---------------------
//리포트
//---------------------
import { getDabangPremiumUpgradeRedirect } from "@/utils/dabangSaleProduct";

const premiumUpgradeBeforeEnter = (to, from, next) => {
  const redirect = getDabangPremiumUpgradeRedirect(
    to.path,
    window.sessionStorage.getItem("dabang_entered"),
    to.query,
  );
  if (redirect) {
    next(redirect);
    return;
  }

  if (localStorage.naezip_to_ac_se) {
    next();
  } else {
    next("/");
  }
};

const reportRouter = [
  {
    path: "/qa/insurance",
    name: "qa-insurance",
    component: () => import("../views/qa/InsuranceQaView.vue"),
  },
  {
    path: "/report",
    name: "report-detail",
    component: () => import("../views/report-data/PreviewView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/report/buy",
    name: "report-buy",
    component: () => import("../views/report-data/BuyPreviewView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/report/buy-renewed",
    name: "report-buy-renewed",
    component: () => import("../views/report-data/BuyPreviewViewRenewed.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/report/buy/balance-date",
    name: "report-buy-balance-date",
    component: () => import("../views/report-data/BuyBalanceDateView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/report/buy/contract-type",
    name: "report-buy-contract-type",
    component: () => import("../views/report-data/BuyContractTypeView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/report/buy-premium-upgrade", //매매프리미엄리포트 업그레이드 결제수단 선택하기 (report_seq 있을 때)
    name: "report-buy-premium-upgrade",
    component: () => import("../views/report-data/BuyUpgradePremiumView.vue"),
    beforeEnter: premiumUpgradeBeforeEnter,
  },
  {
    path: "/report/buy-premium-upgrade-pending", //매매프리미엄리포트 업그레이드 결제수단 선택하기 (order_seq만 있을 때)
    name: "report-buy-premium-upgrade-pending",
    component: () => import("../views/report-data/BuyUpgradePremiumPendingView.vue"),
    beforeEnter: premiumUpgradeBeforeEnter,
  },
  {
    path: "/report/buy-premium-upgrade/complete", //매매프리미엄리포트 업그레이드 결제완료
    name: "report-buy-premium-upgrade-complete",
    component: () => import("../views/report-data/BuyUpgradePremiumCompleteView.vue"),
    beforeEnter: premiumUpgradeBeforeEnter,
  },
  {
    path: "/report/view",
    name: "report-view",
    component: () => import("../views/report-data/PreviewViewAnyone.vue"),
  },
  // [NZSC-3270] 다방 이벤트 페이지 임베드용 리포트 샘플 — 공개(인증 게이트 없음), 픽스처 렌더.
  //   /report/sample/82 (기본) · /report/sample/13 (위험). score 미지정(/report/sample)은 82로.
  {
    path: "/report/sample/:score?",
    name: "report-sample",
    component: () => import("../views/report-data/SampleReportView.vue"),
  },
  {
    path: "/report/view/buy-renewed",
    name: "report-view-buy-renewed",
    component: () => import("../views/report-data/BuyShareViewRenewed.vue"),
  },
  {
    path: "/report/review",
    name: "report-review",
    component: () => import("../views/report/ReportReview.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/report/waiting",
    name: "report-waiting",
    component: () => import("../views/report/ReportWaitingView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/report/realtor",
    name: "report-realtor",
    component: () => import("../views/report-data/RealtorPreviewView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/report/text",
    name: "report-text",
    component: () => import("../views/report/ReportReview.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/report/subscribe-check",
    name: "subscribe-check",
    component: () => import("../views/subscribe_change/SubscribeCheck.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/report/score",
    name: "report-score",
    component: () => import("../views/report/ReportScoreDetailView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },

  {
    path: "/report/waiting/confirm-type",
    name: "report-waiting-confirm-type",
    component: () => import("../views/report/waiting/ReportWaitingType.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/report/waiting/confirm-price",
    name: "report-waiting-confirm-price",
    component: () => import("../views/report/waiting/ReportWaitingPrice.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/report/waiting/confirm-date",
    name: "report-waiting-confirm-date",
    component: () => import("../views/report/waiting/ReportWaitingDate.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/report/waiting/confirm-address",
    name: "report-waiting-confirm-address",
    component: () => import("../views/report/waiting/ReportWaitingAddress.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/report/waiting/confirm-search",
    name: "report-waiting-confirm-search",
    component: () => import("../views/report/waiting/ReportWaitingSearch.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/report/deposit/enter",
    name: "report-deposit-enter",
    component: () => import("../views/deposit/EnterFirstDepositView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/report/deposit/records",
    name: "report-deposit-records",
    component: () => import("../views/deposit/PastRealPriceRecordsView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },

  //기존버전전
  {
    path: "/report/owner-house/advanced-analyze",
    name: "report-owner-house-advanced-analyze",
    component: () => import("../views/report/owner/ReportOwnerHouseAnalyze.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  //2025.03.06 신규버전
  {
    path: "/report/owner-house/analyze",
    name: "report-owner-house-analyze",
    component: () => import("../views/report/owner/ReportOwnerHouseAllOwnersView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/report/owner-house/analysis",
    name: "report-owner-house-analysis",
    component: () => import("../views/report/owner/ReportOwnerHouseAnalysis.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/report/owner-house/pay-complete",
    name: "report-owner-house-pay-complete",
    component: () => import("../views/report/owner/ReportOwnerHousePropertiePayComplete.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },

  //리포트비교
  {
    path: "/report/compare",
    name: "report-compare",
    component: () => import("../views/report/compare/ReportCompareView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/report/compare/list",
    name: "report-compare-list",
    component: () => import("../views/report/compare/ReportCompareListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },

  //재열람
  {
    path: "/report/expiration",
    name: "report-expiration",
    component: () => import("../views/report-data/ReportExpirationView.vue"),
    meta: { hideFooter: true },
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/report/expiration/pay-complete",
    name: "report-expiration-pay-complete",
    component: () => import("../views/report-data/ReportExpirationPayComplete.vue"),
    meta: { hideFooter: true },
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },

  // KCB 법인조회 결과 페이지
  {
    path: "/report/corp-query",
    name: "report-kcb-corp-debt-query-result",
    component: () => import("../views/report/kcb/CorpDebtQueryResult.vue"),
  },
];

export default reportRouter;
